import React from 'react';

export const hasSvg = (children: React.ReactNode): boolean => {
  if (typeof children === 'string') {
    return children.includes('<svg');
  }

  return React.Children.toArray(children).some(
    (child) =>
      React.isValidElement(child) &&
      typeof child.type === 'string' &&
      child.type.toLowerCase() === 'svg',
  );
};
